"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var raf_1 = tslib_1.__importDefault(require("rc-util/lib/raf"));
var StatusQueue = ['measure', 'align', null, 'motion'];
// eslint-disable-next-line import/no-anonymous-default-export
exports.default = (function (visible, doMeasure) {
    var _a = tslib_1.__read((0, react_1.useState)(null), 2), status = _a[0], setInternalStatus = _a[1];
    var rafRef = (0, react_1.useRef)();
    var destroyRef = (0, react_1.useRef)(false);
    function setStatus(nextStatus) {
        if (!destroyRef.current) {
            setInternalStatus(nextStatus);
        }
    }
    function cancelRaf() {
        raf_1.default.cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, raf_1.default)(function () {
            // Only align should be manually trigger
            setStatus(function (prev) {
                switch (status) {
                    case 'align':
                        return 'motion';
                    case 'motion':
                        return 'stable';
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 ? void 0 : callback();
        });
    }
    // Init status
    (0, react_1.useEffect)(function () {
        setStatus('measure');
    }, [visible]);
    // Go next status
    (0, react_1.useEffect)(function () {
        switch (status) {
            case 'measure':
                doMeasure();
                break;
            default:
        }
        if (status) {
            // eslint-disable-next-line require-await
            rafRef.current = (0, raf_1.default)(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                var index, nextStatus;
                return tslib_1.__generator(this, function (_a) {
                    index = StatusQueue.indexOf(status);
                    nextStatus = StatusQueue[index + 1];
                    if (nextStatus && index !== -1) {
                        setStatus(nextStatus);
                    }
                    return [2 /*return*/];
                });
            }); });
        }
    }, [status]);
    (0, react_1.useEffect)(function () { return function () {
        destroyRef.current = true;
        cancelRaf();
    }; }, []);
    return [status, goNextStatus];
});
//# sourceMappingURL=useVisibleStatus.js.map